import React from 'react';
import ProjectCard from './ProjectCard';

const ProjectsGrid = ({ currentProjects, errorMessage, sortedProjects, status }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {status === 'loading' && (
        <div className="col-span-full text-center text-gray-600">
          Loading projects from GitHub...
        </div>
      )}
      {status === 'error' && (
        <div className="col-span-full text-center text-red-600">{errorMessage}</div>
      )}
      {status === 'success' && sortedProjects.length === 0 && (
        <div className="col-span-full text-center text-gray-600">
          Nenhum projeto encontrado para os filtros selecionados.
        </div>
      )}
      {status === 'success' &&
        currentProjects.map((project) => <ProjectCard key={project.id} project={project} />)}
    </div>
  );
};

export default ProjectsGrid;
